import { memo } from 'react';
import Slider from '../../../SliderTwo';
import NewCard from '../../../NewCard';
import VehicleSimilarsLoader from '../../Loader/VehicleSimilars/VehicleSimilarsLoader';
import { PublicationSimilarsProps } from '../../interfaces';
import styles from '../../publicationDetail.module.scss';

const PublicationSimilars = ({
  type,
  brand,
  loading,
  publications,
  clickFavorite,
  sliderLimit
}: PublicationSimilarsProps) => {
  // Solo mostrar para publicaciones normales (no marcas)
  if (type !== "publication" || brand) {
    return null;
  }

  if (loading) {
    return (
      <div className={`${styles.item} ${styles.similars}`}>
        <VehicleSimilarsLoader />
      </div>
    );
  }

  if (!publications || publications.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.item} ${styles.similars} ${publications.length < 1 && styles.noArrows}`}>
      <h2 className={styles.title}>Vehículos similares</h2>
      <div className={styles.content}>
        <Slider
          type="normal"
          perView="auto"
          perGroup={1}
          limit={sliderLimit}
          spaceBetween={12}
          options={
            publications.map((item: any, index: number) => (
              <NewCard
                className={styles.newCard}
                key={index}
                navigation={`/autos/usados/${item.id_publication}`}
                item={item}
                pressFavorite={() => clickFavorite?.(item)}
                redirect={`/autos/usados/${item?.id_publication}`}
                user={null}
                showSecondaryDescription={true}
                showPrimaryDescription={true}
                dealerLogo={item?.branch_data?.picture}
              />
            ))
          }
        />
      </div>
    </div>
  );
};

export default memo(PublicationSimilars);
